import axios from 'axios'

export default {
    namespaced: true,
    actions: {
        fetchStaffs({commit, dispatch}, filter) {
            commit('TOGGLE_PRELOADER', true, {root: true})
            return new Promise((resolve) => {
                axios.get(
                    '/api/mixins/statistics/staff/list',
                    { params: filter }
                ).then(({ data }) => {
                    resolve(data.data)
                }).finally(() => {
                    commit('TOGGLE_PRELOADER', false, {root: true})
                }).catch(error => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        getDetailStaff({commit, dispatch}, payload) {
            commit('TOGGLE_PRELOADER', true, {root: true})
            return new Promise((resolve) => {
                axios.get(
                    '/api/mixins/statistics/staff/detail',
                    { params: payload }
                ).then(({ data }) => {
                    resolve(data.data)
                }).finally(() => {
                    commit('TOGGLE_PRELOADER', false, {root: true})
                }).catch(error => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        }
    }
}
